import React from 'react';
import { Table, Divider, Spin} from "antd";
import {summaryColumnData} from'./columns';
import {getGridTableHeight, getAssetTypeTitle, amountFormatter, floatFormatter} from '../Common/util';
import {Chart01, Chart02} from './Chart';

/** -------------------------------------------------------------------------- **/
function Summary({assetType, measureList, riskScoreList, sumData, spinflag}) {

    return (
        <Spin size={"large"}  tip={"Loading..."} spinning={spinflag}>
            <div id="divTabs1" className="section" style={{height:getGridTableHeight(180), overflowY:'auto'}}>
                <div className="sub_title">
                        {'■ 진단 영역별 보안수준'}
                </div>
                <div style={{padding: '5px 10px'}}>
                <Table 
                        columns={summaryColumnData}
                        dataSource={measureList}
                        scroll={{y: 280}}
                        rowKey="code"
                        pagination={false}
                        bordered size={"small"}
                        className="sub_table"
                        summary={() => {
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0} colSpan={2}>{'관리위험(위험도 ≥ DOA), 잔여위험(위험도 < DOA)'}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={2}>{amountFormatter(sumData.total)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={3}>{amountFormatter(sumData.total_risk)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4}>{amountFormatter(sumData.H)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={5}>{amountFormatter(sumData.M)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={6}>{amountFormatter(sumData.L)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={10}>{floatFormatter(sumData.risk_rate,1)}%</Table.Summary.Cell>
                                  <Table.Summary.Cell index={10}>{amountFormatter(sumData.DoaCount)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={8}>{floatFormatter(sumData.ManagedRisks,1)}%</Table.Summary.Cell>
                                  <Table.Summary.Cell index={9}>{floatFormatter(sumData.UnmanagedRisks,1)}%</Table.Summary.Cell>
                                </Table.Summary.Row>
                              </>
                            );
                        }}
                        >
                    </Table>
                </div>
                <Divider />
                <div className="sub_title">
                        {'■ ' + getAssetTypeTitle(assetType) + ' 영역별 위험 관리 비율'}
                </div>
                <div style={{padding: '5px 10px', height: '200px'}}>
                    <Chart01 dataList={measureList} sumData={sumData} />
                </div>
                <Divider />
                <div className="sub_title">
                        {'■ ' + getAssetTypeTitle(assetType) + ' 위험도별 통계'}
                </div>
                <div style={{padding: '5px 10px', height: '400px'}}>
                    <Chart02 dataList={riskScoreList} sumData={sumData} />
                    <p>&nbsp;</p>
                </div>
            </div>
        </Spin>
    );
}
export default Summary;